<template>
  <div class="blog-container" v-loading="loading">
    <div class="blog-wrapper">
      <div class="blog-box">
        <!-- <div class="blog-header">
          <h1>{{ blogTitle }}</h1>
          <p>最近更新： {{ updateTime }}</p>
        </div> -->
        <Editor
          style="border-top: none; overflow-x: hidden; padding: 0 20px"
          :editor-id="editorId"
          :default-config="editorConfig"
          :default-html="blogContent"
          mode="default"
          @onChange="handleChangeContent"
        />
      </div>
    </div>
    <div class="catalogue-wrapper">
      <span class="cata-title">文章目录</span>
      <SideCatalogue
        :catalogueList="catalogueList"
        :currentCataDomId="currentCataDomId"
        @scrollTo="scrollTo"
      />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import SideCatalogue from "@/components/sideCatalogue";
import { getArticleById } from "@/api/blog";
import { createEditor, DomEditor, SlateNode } from "@wangeditor/editor";
import "@wangeditor/editor/dist/css/style.css";
import {
  Editor,
  Toolbar,
  getEditor,
  removeEditor,
} from "@wangeditor/editor-for-vue";
import { mapState } from "vuex";

export default {
  components: {
    SideCatalogue,
    Editor,
  },
  name: "Blog",
  data() {
    return {
      loading: false,
      blogTitle: "",
      blogContent: "",
      updateTime: "",
      catalogueList: [],
      currentCataDomId: "",
      editorId: `w-e-${Math.random().toString().slice(-5)}`,
      editorConfig: {
        // readOnly: true,
      },
    };
  },
  watch: {
    $route: {
      handler(val) {
        val.query.blogid && this.getBlogDetail(val.query.blogid);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapState([
      "title",
      "registerIcon",
      "menulist",
      "menutree",
      "currentBlogId",
    ]),
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 位置距离（自定义）
      let range = 300;
      for (let dom of this.catalogueList) {
        // 获取到该标题的位置 top值
        let top = document.getElementById(dom.id).getBoundingClientRect().top;
        if (top >= 0 && top <= range) {
          // 改变currentCataDomId的值
          this.currentCataDomId = dom.id;
          // 直接结束，其他dom不需要设置了
          return;
        } else if (top > range) {
          // top值不在范围内，直接结束说明之前添加过了currentCataDomId的值
          return;
        } else {
          // top值小于0
          // 修改currentCataDomId的值，继续循环doms，可能其他的标题符合修改情况
          this.currentCataDomId = dom.id;
        }
      }
    },
    async getBlogDetail(id) {
      this.loading = true;
      const resp = await getArticleById({ id });
      this.blogTitle = resp.data
        ? resp.data.title.replace(/replacestr1024/g, this.title)
        : "";
      this.blogContent = resp.data
        ? resp.data.content.replace(/replacestr1024/g, this.title)
        : "";
      this.updateTime = resp.data ? resp.data.updateTime : "";
      await this.randerContent();
      this.loading = false;
    },
    handleChangeContent(editor) {
      const headers = getEditor(this.editorId).getElemsByTypePrefix("header");
      this.catalogueList = headers.map((header) => {
        const text = SlateNode.string(header);
        const { id, type } = header;
        return {
          text,
          id,
          type,
        };
      });
    },
    async randerContent() {
      if (getEditor(this.editorId).isDisabled()) {
        await getEditor(this.editorId).enable();
      }
      await getEditor(this.editorId).clear();
      this.$nextTick(() => {
        getEditor(this.editorId).dangerouslyInsertHtml(
          `<p key='${new Date().getTime().toString()}'>${this.blogContent}</p>`
        );
        this.$nextTick(() => {
          this.handleScroll();
          if (!getEditor(this.editorId).isDisabled()) {
            getEditor(this.editorId).disable();
          }
          // getEditor(this.editorId).blur();
          // console.log(getEditor(this.editorId).isFocused());
        });
      });
    },
    scrollTo(id) {
      const h = document.getElementById(id).getBoundingClientRect().top;
      const top = document.documentElement.scrollTop;
      window.scrollTo(0, h + top - 85);
    },
  },
};
</script>
<style lang="scss" scoped>
.blog-container {
  padding-right: 16vw;
  box-sizing: border-box;
  position: relative;
  .blog-wrapper {
    height: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    background: rgba(0, 0, 0, 0.03);
    .blog-box {
      background: #fff;
      // max-width: calc(100% - 20px);
      width: 100%;
      padding: 10px 0;
      .blog-header {
        padding: 0 10px;
        margin: 0 20px;
        border-bottom: 1px solid #ccc;
        h1 {
          font-size: 2.2em;
          line-height: 45px;
          color: #36383d;
          font-weight: 600;
          margin-bottom: 8px;
        }
        p {
          color: #999;
          font-size: 13px;
        }
      }
    }
  }
  .catalogue-wrapper {
    position: fixed;
    box-sizing: border-box;
    top: 72px;
    right: 0;
    .cata-title {
      font-size: 15px;
      padding: 0 10px;
      line-height: 60px;
      font-weight: 600;
    }
  }
}
</style>
<style lang="scss">
.w-e-text-container [data-slate-editor] {
  overflow-x: hidden;
}
</style>
